/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Sms/view.blocks to change it.
import MobilePhoneIcon from 'DesignSystem/Svgs/MobilePhoneIcon/index'
import Name from './Name/index'
import Phone from './Phone/index'
import React from 'react'
import StatusTooltip from './StatusTooltip/index'
import styles from './view.module.css'
import useIsHovered from 'Simple/hooks/useIsHovered'



/** @type {import('Simple/types.js').View} */
export default function Sms({
  children,
  viewPath = "/DesignSystem/CommsThread/Content/Topbar/Sms",
  onClick
  
}) {
let [isHovered, isSelectedHovered, isHoveredBind] = useIsHovered({})
  return (<React.Fragment
>
<button
  data-testid="Sms.Vertical"
  data-view-path={viewPath}
 {...isHoveredBind}
 onClick={onClick}
 className={`views-block ${styles.Vertical}`}
>
<MobilePhoneIcon
  viewPath={`${viewPath}/MobilePhoneIcon`}
 marginRight={4}
 width={16}
 height={16}
 stroke="rgba(0,0,0,0.7)"
/>
<StatusTooltip
  viewPath={`${viewPath}/StatusTooltip`}
 flowNo={!isHovered}
 flowContent={isHovered}
/>
</button>
<Name
  viewPath={`${viewPath}/Name`}
/>
<Phone
  viewPath={`${viewPath}/Phone`}
/>
{children}
</React.Fragment>)
}